<template>
  <div class="profile">
    <div class="fl">
      <Menu :active-name="activeKey">
        <Menu-group title="人才发展">
          <Menu-item
            v-for="item in list"
            :key="item.id"
            :to="item.route"
            :name="item.id"
            >{{ item.name }}</Menu-item
          >
        </Menu-group>
      </Menu>
    </div>
    <div class="fr">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          id: 1,
          route: "/chaofang",
          name: "超房网",
        },
        {
          id: 2,
          route: "/shangxueyuan",
          name: "商学院",
        },
        {
          id: 3,
          route: "/recruit",
          name: "招聘",
        },
      ],
      activeKey: 1,
    };
  },
  updated() {
    let list = this.list;
    let path = this.$route.path;
    let data = list.filter((item) => {
      return item.route == path;
    });
    this.activeKey = data[0].id;
  },
  mounted() {
    let list = this.list;
    let path = this.$route.path;
    let data = list.filter((item) => {
      return item.route == path;
    });
    this.activeKey = data[0].id;
  },
};
</script>

<style scoped>
.profile {
  width: 1000px;
  display: flex;
  min-height: 700px;
  padding-bottom: 40px;
  margin: 0 auto;
}
.fl {
  width: 200px;
}
.ivu-menu.ivu-menu-light.ivu-menu-vertical {
  width: 100% !important;
  height: 100%;
}
.ivu-menu-item-group {
  width: 100%;
}
.ivu-menu-item-group ul {
  width: 100%;
}
.ivu-menu-vertical.ivu-menu-light:after {
  background-color: #fff;
}
.ivu-menu-item {
  width: 100%;
}
.ivu-menu {
  z-index: 0;
}
.fr {
  flex: 1;
  /* padding: 0 20px; */
  box-sizing: border-box;
  border-left: 1px solid #f0f0f0;
}
</style>
